import { SingleVotingNote } from "store/voting/types";

export const getUserNoteFromVotingNotes = (
  userId: number | undefined,
  notes: SingleVotingNote[] | undefined
) => {
  return notes?.find((note) => note.creator_id === userId);
};

export const getDownloadVotingSignedSummaryUrl = (
  votingId: number,
  summaryId: string
) => `/votings/${votingId}/summary/download-signed-summary/${summaryId}`;
